import { getPatientInfoEndpoint } from '../../utils/apiHelper'
import { apiCall } from '../../utils/restclient'
import { GET_PATIENT_INFORMATION_SUCCESS } from './PatientConstants'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getPatient = (patientId, tabId, types) => {
  const endpoint = getPatientInfoEndpoint(patientId)
  const action = {
    type: types.loadAction,
    extraData: { tabId },
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_PATIENT_INFORMATION_SUCCESS,
      error: types.errorAction,
      extraData: { patientId, tabId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
